import { SET_SERVERS } from './constants'

const initialState = {}

// sample state:
// const initialState = {
//     tq: 'Tranquility',
//     sisi: 'Singularity',
// }

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // Locale changed
        case SET_SERVERS: {
            return { ...action.payload }
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Settings/data/servers/reducers.js